import {
  CommonParamsType,
  CommonSuccessResponse,
} from "constants/types/common";
import { BankAccountResponseType } from "constants/types/bankAccount";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const getBankAccountListKey = (params?: CommonParamsType) => {
  return `/bank-account?${serialize({ ...params })}`;
};

export const useBankAccounts = (params?: CommonParamsType) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<BankAccountResponseType[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(getBankAccountListKey(params), { refreshInterval: 0 });

  const pagination = data?.meta;
  const bankAccounts = data?.data;

  return {
    bankAccounts,
    pagination,
    error,
    isLoading,
    mutate,
  };
};

export const useListBankAccount = () => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<BankAccountResponseType[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR("/bank-account/all", {
    refreshInterval: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const bankAccountList = data?.data ?? [];

  const bankAccountOptions = bankAccountList.map((bankAccount) => ({
    label: `${bankAccount.bankName} - ${bankAccount.accountNumber}`,
    value: bankAccount.id,
  }));

  return {
    bankAccountList,
    bankAccountOptions,
    error,
    isLoading,
    mutate,
  };
};
